import React, { useState } from 'react';
import { KoButton, KoPagination, KoSearch, KoTable, KoTitle, KoTooltips } from 'packages';
import ProductObject from './constant';
import KoIcon from '@kwapio/icons';
import styles from './productList.module.scss';
export default function ProductList() {
  const [totalCount ] = useState(0);
  const [pagination, setPagination ] = useState({
    size: 100,
    page: 1
  });

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (data, row) => (
      <div className={`${styles.table} tableBtn columnsRight`} >
        <KoTooltips title={'New Window'}>
          <KoButton
            size="small"
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={14} height={14} name={'OpenOutlined'} />}
          />
        </KoTooltips>
        <KoTooltips title={'Edit'}>
          <KoButton
            size="small"
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={14} height={14} name={'EditOutlined'} />}
          />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton
            size="small"
            className={'btn'}
            iconBtn={true}
            icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />}
          />
        </KoTooltips>
      </div>
    )
  }];


  return (
    <div className={`tableCard`}>
      <div className={styles.tableHeader}>
        <KoTitle text='All Products' level={5}/>
        <KoSearch/>
      </div>
      <KoTable
        extraColumnsRight={columnsRight}
        maxHeight={66}
        data={{ columns: ProductObject.PRO_ITEMS_COLUMNS, rows: ProductObject.ROWS }}
      />
      <KoPagination current={parseInt(pagination.page) || 1}
        total={totalCount}
        showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
        }
        pageSize={pagination.limit}
        defaultCurrent={pagination.page}
        onChange={onPagination}
        showQuickJumper={false}
        simple={false}
        responsive={false} />
    </div>
  );
}
